import { Size } from "@/api/AppApi/common-interfaces/api-enums";
import { IHtmlBlock } from "../../home/interfaces/HtmlBlocks";

export enum InputTypes {
  text = "text",
  email = "email",
}
export enum MenuItemType {
  category = "category",
  brand = "brand",
  inner_page = "inner-page",
  menu_item = "menu-item",
  contact_us = "contact-us",
  blogs = "blogs",
  more = "more",
}
// export interface IMenuItem {
//   title: string;
//   type: MenuItemType;
//   value: string;
// }
export interface ICompanySubMenu {
  title: string;
  type: MenuItemType;
  value: string;
  sub_menu: ICompanySubMenu[];
  parentId?: string | null;
  slug?: string;
}
export enum HeaderAlignmentTypes {
  end = "end",
  center = "center",
}
export enum HeaderStyleTypes {
  logo = "logo",
  title = "title",
  logo_title = "logo_title",
  stacked = "stacked",
  none = "none",
}
export enum SearchBarVisibility {
  mobile = "mobile",
  desktop = "desktop",
  both = "both",
  none = "none",
}
export enum AttributesSelectionMethods {
  all = "all",
  cascading = "cascading",
}
export interface IHeaderTheme {
  alignment: HeaderAlignmentTypes;
  cart_button_bg_color: string;
  cart_button_color: string;
  header_bg_color: string;
  header_color: string;
  header_icons_color: string;
  logo: string;
  logo_height: number | null;
  reverse_logo: string;
  show_company_name: true;
  sticky_header_color: string;
  style: HeaderStyleTypes;
  show_logo: boolean;
  show_title: boolean;
  search_bar_visibility: SearchBarVisibility;
  mobile_style: "sticky_bottom" | "normal";
  // style: "1";
}
export interface IProductTheme {
  add_to_cart_bg_color: string;
  add_to_cart_color: string;
  allow_add_configurable_product_to_cart: boolean;
  add_to_cart_btn_title: string;
  card_bg_color: string;
  card_border_color: string;
  customer_notes_label: string;
  enable_product_share_icons: boolean;
  allow_user_request_stock_availability_reminder: boolean;
  image_ratio: number;
  // image_size: string;
  product_box_style: Size;
  name_color: string;
  price_color: string;
  related_products_asgrid: boolean;
  similar_products_asgrid: boolean;
  related_products_title: string;
  similar_products_title: string;
  product_reviews_visibility: ReviewVisibility;
  row_size: number;
  show_add_to_card_btn: boolean;
  show_addons_on_popup: boolean;
  show_brand: boolean;
  show_category_image: boolean;
  show_subcategory_image: boolean;
  show_customer_note_as_popup: false;
  show_customer_notes: boolean;
  show_description: boolean;
  show_description_in_grid_mobile: true;
  show_discount_badge: boolean;
  show_go_to_cart_popup: boolean;
  show_new_badge: boolean;
  show_name: boolean;
  show_related_products: boolean;
  show_similar_products: boolean;
  show_sku: boolean;
  show_specification_section: boolean;
  show_upsell_products: boolean;
  show_all_product_units: boolean;
  upsell_products_asgrid: boolean;
  upsell_products_title: string;
  add_to_cart_style: "plus_icon" | "add_cart_button";
  sale_badge_style: "value" | "label";
  attributes_selection_methods: AttributesSelectionMethods;
  auto_select_first_child_in_show_product: boolean;

  //not used yet
  badge_alignment: "auto";
  max_product_unit: 2;
  show_calender_as_popup: boolean;
  product_image_object_fit: "contain" | "cover" | "fill";
  enable_taxes: boolean;
  quick_variant_selection: boolean;
  show_low_stock_alert: boolean;
  min_stock_quantity_to_show_alert: number;
  show_sold_quantity_badge: boolean;
  show_buy_now_btn:boolean
}

export interface ICartTheme {
  crosssell_products_asgrid: boolean;
  crosssell_products_title: string;
  minimum_order_amount: number | null;
  show_coupon_field: boolean;
  show_crosssell_products: boolean;
}
export interface IColors {
  floating_color: string;
  floating_inner_color: string;
  new_badge_bg_color: string;
  new_badge_color: string;
  primary_color: string;
  primary_inner_color: string;
  sale_badge_bg_color: string;
  sale_badge_color: string;
  secondary_color: string;
  secondary_inner_color: string;
  mobile_match_desktop_design: boolean;
}
export enum Layouts {
  advanced = "advanced", //?
}
export interface ITabsTheme {
  bg_color: string;
  categories_style_on_header: "links_in_menu" | "menu";
  color: string;
  menu_background_image: boolean;
  weight: string;
}
export interface ISettingsTheme {
  basic_language: "ar" | "en";
  customer_login_methods: LoginMethodTypes;
  enable_currencies_converter: boolean;
  enable_direct_calls: boolean;
  enable_floating_social_icons: boolean;
  enable_sells: boolean; //will be removed
  enable_social_login: boolean;
  enable_whatsapp: boolean;
  facebook_code: string;
  tiktok_code: string;
  features: {
    appointments: boolean;
    consultations: boolean;
    orders: boolean;
    school: boolean;
  };
  google_analytics_id: string;
  google_tag: string;
  message_of_open_store: string;
  show_cart: boolean;
  show_follow_us_section: boolean;
  show_message_open_store: boolean;
  smartlook_code: string;
  snapchat_code: string;
  splash_logo: string;
  favicon_image: string;
  enable_website_caching_enhancement: boolean;
  enable_checkout_for_guests: boolean;
  selling_mode: SellingMode;
  open_at?: string | null; //hh:mm
  close_at?: string | null; //hh:mm
}
export interface IFooterTheme {
  bg_color: string;
  color: string;
  show_logo: boolean;
  show_social_icons: boolean;
  zfloos_copyright: boolean;
  footer_logo: string;
  footer_custom: IHtmlBlock["data"] | null;
}
export interface IBodyTheme {
  ar_font_family: string;
  bg_color: string;
  bg_image: string;
  btns_bg_color: string;
  btns_color: string;
  color: string;
  en_font_family: string;
  input_bg_color: string;
  input_color: string;
  section_heading_color: string;
  layout_standard_width: boolean;
  pagination_mode: PaginationModes;
}
export interface ITheme {
  colors: IColors;
  components: {
    body: IBodyTheme;
    cart: ICartTheme;
    footer: IFooterTheme;
    get_app: {
      android_url_app: string;
      ios_url_app: string;
      show_in_header: boolean;
      show_in_footer: boolean;

      app_store_id: string;
      google_play_id: string;
    };
    header: IHeaderTheme;
    product: IProductTheme;
    tabs: ITabsTheme;
  };
  homepage_layout: Layouts;
  settings: ISettingsTheme;
  seo: ISeo;
  firebase_config?: FirebaseConfig;
}

export interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
}

export interface ISeo {
  meta_description: string;
  meta_keyword: string;
  meta_title: string;
  og_description: string;
  og_image: string;
  og_site_name: string;
  og_title: string;
}
export interface IMapLocation {
  lat: number;
  lng: number;
}
export interface IDeliveryTimeSlot {
  single_day_working_hours?: string;
  day_of_week: string;
  periods: { from: string; to: string }[];
}
export interface IWorkingHours {
  single_day_working_hours?: string;
  day_of_week: string;
  periods: {
    open_at: string; //"07:00"
    closes_at: string;
  }[];
}
export interface ILanguage {
  name: string;
  code: string;
  is_rtl: boolean;
}
export interface IBranch {
  address: string;
  id: number;
  image_url: string;
  map_location: IMapLocation;
  mobile: string;
  name: string;
  thumbnail_url: string;
  working_hours: IWorkingHours[];
  local_address?: number;
  local_name?: string;
}

export enum DeliveryMethodsTypes {
  delivery = "delivery",
  pickup = "pickup",
  dining_in = "dining_in",
  online = "online",
}
export interface ICountry {
  id: number;
  name: string;
  code: string;
}
export interface ICompanyAddress {
  address: string;
  area: string;
  city: string;
  country: string;
  location: {
    lat: number;
    lng: number;
  };
  other_address: string;
  country_code?: string | null;
}
export interface ICompanyServiceDesk {
  email: string;
  iso2: string;
  mobile: string;
  name: string;
}
export interface ICompanySocialMedia {
  icon: string;
  url: string;
}
export interface IContacts {
  address: ICompanyAddress;
  email: string;
  phones: string[];
  service_desk: ICompanyServiceDesk[];
  social_media: ICompanySocialMedia[];
}
export interface ISupportedCurrency {
  code: string;
  decimal_digits: number;
  exchange_rate: number;
  flag: string; //url
  name: string;
  selected: boolean;
  symbol: string;
}
interface Link {
  title: string;
  url: string;
}
export interface ILinkSubMenu {
  title: string;
  links: Link[];
}

export enum CompanyFilterTypes {
  bestSeller = "bestSeller",
  saleItems = "saleItems",
  newArrival = "newArrival",
}

export enum OrderTypes {
  on_hold = "on_hold",
  refunded = "refunded",
  fulfilled = "fulfilled",
  shipped = "shipped",
  processed = "processed",
  opened = "opened",
  canceled = "canceled",
  pending = "pending",
  completed = "completed",
}
export enum LottieFileTypes {
  btn_loader = "btn_loader",
  cart = "cart",
  click_loader = "click_loader",
  email_verification = "email_verification",
  general_loader = "general_loader",
  location = "location",
  mobile_verification = "mobile_verification",
  no_appointments = "no_appointments",
  no_data = "no_data",
  no_consultations = "no_consultations",
  no_products = "no_products",
  no_result = "no_result",
  notification = "notification",
  payment_fail = "payment_fail",
  payment_success = "payment_success",
  registration = "registration",
  search = "search",
}
export interface IFavoriteFilter {
  key: CompanyFilterTypes;
  value: string;
}

export interface IStatusType {
  color: string;
  key: OrderTypes;
  value: string;
}
export interface ISortType {
  key: string;
  value: string;
}
export interface IPaymentMethod {
  id: number; //?
  gateway_id: number;
  name: string;
  description: string;
  icon: string;
  provider?: string;
  hint?: string;
}
export interface IInnerPage {
  icon: string;
  show_in_footer: boolean;
  show_in_header: boolean;
  slug: string;
  title: string;
  url: string;
}
export enum LoginMethodTypes {
  by_email = "by_email",
  by_phone = "by_phone",
  both = "both",
  any = "any",
  none = "none",
}
export interface ICustomScript {
  footer: string;
  header: string;
  style: string;
}
export interface ICompany {
  branches: IBranch[];
  company_base_currency: string;
  contacts: IContacts;
  custom_scripts: ICustomScript;
  countries: ICountry[];
  // delivery_methods: DeliveryMethodsTypes[];
  dial_code_countries: []; //to be deleted
  favorite_filters: IFavoriteFilter[];
  fieldwork: string; //ex: Clothing
  id: number;
  inner_pages: IInnerPage[];
  languages: ILanguage[];
  // links: ILinkSubMenu[];
  logo: string; //url
  lottie_files: {
    [x in LottieFileTypes]: string;
  };
  menu: ICompanySubMenu[];
  footer_menu: ICompanySubMenu[];
  name: string;
  status_types: {
    consultations: IStatusType[];
    appointments: IStatusType[];
    applications: IStatusType[];
    orders: IStatusType[];
    payments: IStatusType[];
  };
  payment_methods: IPaymentMethod[];
  shipping_settings: IShippingSettings;
  preferences?: {
    tabby_integration: boolean;
    tamara_integration?: boolean;
  };
  sort_types: {
    appointments: ISortType[];
    orders: ISortType[];
    products: ISortType[];
    applications: ISortType[];
  };
  // supported_currencies: ISupportedCurrency[]; //!! should to be not used, we will use the useGetCurrencies to get the supported currencies
  theme: ITheme;
  translations: {
    [slug: string]: string;
  };
  show_receiving_header: boolean;
  allow_user_select_receiving_branch: boolean;

  enable_store?: boolean;
  disable_store_message?: string;

  //===================================================================

  seo: any; //not in api
}
export interface IShippingSettings {
  enable_pickup: boolean;
  pickup_not_available_message: string;
  enable_shipping: boolean;
  shipping_not_available_message: string;
  appearance_show_time_slot: ShowTimeSlotTypes;
  appearance_show_delivery_date: ShowDeliveryDate;
  appearance_calender_display_mode: CalenderDisplayMode;
}
export enum ShowTimeSlotTypes {
  drop_down = "drop_down",
}
export enum ShowDeliveryDate {
  drop_down = "drop_down",
  calender = "calender",
}
export enum CalenderDisplayMode {
  always_open = "always_open",
  on_page_load = "on_page_load",
}
export enum PaginationModes {
  traditional = "traditional",
  scroll = "scroll",
  button = "button",
}
// Generated by https://quicktype.io
export enum ReviewVisibility {
  all = "for_all",
  buyers = "for_buyers",
  none = "not_visible",
}

export enum SellingMode {
  publicForAll = "enabled",

  signedUpOnly = "signed_up_only",

  disableSells = "disabled",

  requiredCheckoutForGuests = "require_registration_on_checkout",
}
